import { useEffect, useState } from "react";
import { bg, loadFont } from "@/lib/themes";

export const ThemeBackdrop = ({ theme, fixed = true }) => {
  const [ready, setReady] = useState(false);
  const wide = bg(theme, "wide");
  const tall = bg(theme, "tall");
  useEffect(() => {
    loadFont(theme?.font);
    setReady(false);
    if (!wide) return;
    const img = new Image();
    img.onload = () => setReady(true);
    img.src = window.matchMedia("(max-aspect-ratio: 1/1)").matches ? tall : wide;
  }, [wide, tall, theme?.font]);
  if (!wide) return null;
  return (
    <div className={`theme-backdrop ${fixed ? "" : "theme-backdrop-abs"} ${ready ? "on" : ""}`}
      style={{ "--bg-wide": `url(${wide})`, "--bg-tall": `url(${tall})` }} data-testid="theme-backdrop" data-theme={theme.key} aria-hidden />
  );
};
